import React from 'react';
import Table from '../components/atoms/Table';
import Input from '../components/atoms/Input';
import Button from '../components/atoms/Button';
import PopupTemp from './PopupTemp';

const PopupLandInfo = ({ list, objectPolygon, setList }) => {
  //닫기 버튼
  const onClose = () => {
    setList([]);
    objectPolygon?.onClickPointClear();
  };

  return (
    <PopupTemp width={360} title={'지적 정보'} onClose={onClose}>
      <Table
        caption={'지적 정보'}
        colgroup={[120, 'auto']}
        type={'row'}
        $cellHeight={56}
        tbody={
          <>
            <tr>
              <th scope={'row'}>PNU</th>
              <td className={'txt-left'} style={{ padding: '0 14px 0 14px' }}>
                {list[0].getProperties()?.pnu}
              </td>
            </tr>
            <tr>
              <th scope={'row'}>주소</th>
              <td className={'txt-left'} style={{ padding: '0 14px 0 14px', wordBreak: 'keep-all' }}>
                {list[0].getProperties()?.addr}
              </td>
            </tr>
            <tr>
              <th scope={'row'}>기준년월</th>
              <td className={'txt-left'} style={{ padding: '0 14px 0 14px' }}>
                {list[0].getProperties()?.gosi_year ? list[0].getProperties()?.gosi_year + '년 ' + list[0].getProperties()?.gosi_month + '월' : '-'}
              </td>
            </tr>
          </>
        }
      />
    </PopupTemp>
  );
};

export default PopupLandInfo;
